// Gatsby requirements
import React from "react"
import { render, MARK_LINK, NODE_IMAGE, NODE_HEADING } from 'storyblok-rich-text-react-renderer';
import { Link } from 'gatsby';

// Components
import Button from 'utils/linkLogic';
import Hero from '../components/sectionHero'
import Cards from '../components/sectionCards'
import TextAndImage from '../components/sectionTextAndImage'
import Logos from '../components/sectionLogos'
import CategoryList from '../components/sectionCategoryList'
import Testimonial from '../components/sectionTestimonial'
import Faq from '../components/sectionFaq'
import Cta from '../components/sectionCta'
import Table from '../components/sectionTable'
import AdList from '../components/sectionAdList'
import NumberedVerticalCards from '../components/sectionNumberedVerticalCards'
import ListOfArticles from '../components/sectionListOfArticles'
import Breadcrumbs from '../components/breadcrumbs'
import PricingCards from '../components/sectionPricingCards'
import ContactForm from '../components/sectionContactForm'
import Timeline from '../components/sectionTimeline'
import TableOfContents from '../components/sectionTableOfContents'
import ProductComparison from '../components/sectionProductComparison'
import ShareButtons from '../components/sectionShareButtons'
import Html from '../components/sectionHtml'
import SectionReviews from '../components/sectionReviews'
import SectionReviewForm from '../components/sectionReviewForm'
import SectionProsAndCons from '../components/sectionProsAndCons'


const RichTextRenderer = ({ data, currentPage, className, currentPageName }) => {
    
    return (
        <div className={className}>
            {render(data, {
                nodeResolvers: {
                    [NODE_IMAGE]: (children, props) => {
                        return(
                            <img
                                srcSet={`
                                    ${props.src + '/m/1200x0/filters:quality(90)'} 1200w,
                                    ${props.src + '/m/1000x0/filters:quality(90)'} 1000w,
                                    ${props.src + '/m/800x0/filters:quality(90)'} 800w,
                                    ${props.src + '/m/700x0/filters:quality(90)'} 700w,
                                    ${props.src + '/m/600x0/filters:quality(90)'} 600w,
                                    ${props.src + '/m/500x0/filters:quality(90)'} 500w,
                                    ${props.src + '/m/400x0/filters:quality(90)'} 400w,
                                    ${props.src + '/m/300x0/filters:quality(85)'} 300w
                                `}
                                sizes="(min-width: 1200px) 1200px, 100vw"
                                src={props.src}
                                width={props.src?.split('/')[5]?.split('x')[0]}
                                height={props.src?.split('/')[5]?.split('x')[1]}
                                alt={props?.alt}
                                loading="lazy"
                            />
                        )
                    },

                    [NODE_HEADING]: (children, { level }) => {
                        if (children !== null) {
                            if (level === 1) {return( <h1 id={children[0]?.props?.children?.props?.children !== undefined ? children[0]?.props?.children?.props?.children.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0]?.props?.children !== undefined ? children[0]?.props?.children?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0].props === undefined ? children[0]?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : ''}>{children}</h1> )}
                            if (level === 2) {return( <h2 id={children[0]?.props?.children?.props?.children !== undefined ? children[0]?.props?.children?.props?.children.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0]?.props?.children !== undefined ? children[0]?.props?.children?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0].props === undefined ? children[0]?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : ''}>{children}</h2> )}
                            if (level === 3) {return( <h3 id={children[0]?.props?.children?.props?.children !== undefined ? children[0]?.props?.children?.props?.children.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0]?.props?.children !== undefined ? children[0]?.props?.children?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0].props === undefined ? children[0]?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : ''}>{children}</h3> )}
                            if (level === 4) {return( <h4 id={children[0]?.props?.children?.props?.children !== undefined ? children[0]?.props?.children?.props?.children.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0]?.props?.children !== undefined ? children[0]?.props?.children?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0].props === undefined ? children[0]?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : ''}>{children}</h4> )}
                            if (level === 5) {return( <h5 id={children[0]?.props?.children?.props?.children !== undefined ? children[0]?.props?.children?.props?.children.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0]?.props?.children !== undefined ? children[0]?.props?.children?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0].props === undefined ? children[0]?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : ''}>{children}</h5> )}
                            if (level === 6) {return( <h6 id={children[0]?.props?.children?.props?.children !== undefined ? children[0]?.props?.children?.props?.children.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0]?.props?.children !== undefined ? children[0]?.props?.children?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : children[0].props === undefined ? children[0]?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') : ''}>{children}</h6> )}
                        }
                    }
                },

                markResolvers: {

                    // Use <Link> or <a> depending on link type
                    [MARK_LINK]: (children, props) => {
                        if (props) {
                            const { href, target, linktype } = props;
                            if (linktype === 'story') { 
                                return (
                                    <Link
                                        to={href === 'home' ? '/' : href?.endsWith("/") === true ? href : href + '/'}
                                        className={data.component === "Button" ? 'button' : ''}
                                        target={target}
                                    >
                                        {children}
                                    </Link>
                                )
                            }

                            if (linktype === 'url') {
                                return (
                                    <a
                                        href={href}
                                        target={target}
                                    >
                                        {children}
                                    </a>
                                )
                            }

                            if (linktype === 'asset') {
                                return (
                                    <a
                                        href={href}
                                        target={target}
                                        className="asset-icon"
                                    >
                                        {children}
                                    </a>
                                )
                            }
                        }
                    },
                },

                // Use custom blocks
                blokResolvers: {
                    ['Button']: (props) => <Button insertClass="button" data={props} />,
                    ['Section: Hero']: (props) => <Hero blok={props} />,
                    ['Section: Cards']: (props) => <Cards blok={props} />,
                    ['Section: Text and Image']: (props) => <TextAndImage blok={props} />,
                    ['Section: Logos']: (props) => <Logos blok={props} />,
                    ['Section: Category List']: (props) => <CategoryList blok={props} />,
                    ['Section: Testimonial']: (props) => <Testimonial blok={props} />,
                    ['Section: Faq']: (props) => <Faq blok={props} />,
                    ['Section: Call to Action']: (props) => <Cta blok={props} />,
                    ['Section: Table']: (props) => <Table blok={props} />,
                    ['Section: Ad List']: (props) => <AdList blok={props} />,
                    ['Section: Numbered Vertical Cards']: (props) => <NumberedVerticalCards currentPage={currentPage} blok={props} />,
                    ['Section: List of Articles']: (props) => <ListOfArticles blok={props} />,
                    ['Section: Breadcrumbs']: (props) => <Breadcrumbs currentPage={currentPage} currentPageName={currentPageName} blok={props} />,
                    ['Section: Pricing Cards']: (props) => <PricingCards blok={props} />,
                    ['Section: Contact Form']: (props) => <ContactForm currentPage={currentPage} blok={props} />,
                    ['Section: Table of Contents']: (props) => <TableOfContents blok={props} />,
                    ['Section: Timeline']: (props) => <Timeline blok={props} />,
                    ['Section: Product Comparison']: (props) => <ProductComparison blok={props} />,
                    ['Section: Share Buttons']: (props) => <ShareButtons blok={props} />,
                    ['Section: Html']: (props) => <Html blok={props} />,
                    ['Section: Reviews']: (props) => <SectionReviews blok={props} />,
                    ['Section: Review Form']: (props) => <SectionReviewForm currentPage={currentPage} blok={props} />,
                    ['Section: Pros and Cons']: (props) => <SectionProsAndCons blok={props} />,
                },

            })}
        </div>
    )
}

export default RichTextRenderer